import type { PhoneState } from './phoneState'

const BUSY_CALL_STATES = new Set<PhoneState['state']>([
  'calling',
  'connected',
  'incoming',
  'ringing',
])

export function isBusyWithPhoneCall(
  phoneState: PhoneState,
): phoneState is Extract<
  PhoneState,
  { state: 'calling' | 'connected' | 'incoming' | 'ringing' }
> {
  return BUSY_CALL_STATES.has(phoneState.state)
}
